import { render, staticRenderFns } from "./ReportingComponent.vue?vue&type=template&id=39f78672"
import script from "./ReportingComponent.vue?vue&type=script&lang=js"
export * from "./ReportingComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportingComponent.vue?vue&type=style&index=0&id=39f78672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports